interface Route {
  fullPath: string
}

export const update = (to?: Route) => {
  window.preventSentryLogging = true

  if (to) {
    window.location.href = to.fullPath
  } else {
    window.location.reload()
  }
}
